import PropTypes from "prop-types";
import SelectionSiteItemType from "utils/selectionSiteItemTypeUtils";

const ItemType = PropTypes.oneOf(SelectionSiteItemType.VALUES);

export default ItemType;
